<template>
	<div class="radio">
		<input class="radio__input" :id="id" :name="name" type="radio" :value="value" v-model="radio">
		<label class="label radio__label" :for="id">
			<span class="visually-hidden">{{screenLabel}}</span>
			<span :class="{ 'visually-hidden--medium' : hideLabel }">{{label}}</span>
		</label>
	</div>
</template>

<script>
export default {
	name: 'RadioButton',
	props: {
		id: String,
		name: String,
		label: String,
		screenLabel: String,
		hideLabel: Boolean,
		value: Number
	},
	computed: {
		radio: {
			get: function() {
				return this.label
			},
			set: function() {
				this.$emit("change", this.value)
			}
		}
	}
}
</script>